import { Component } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';

@Component({
    selector: 'rwidget-ticket-animation',
    templateUrl: './ticket-animation.component.html',
    styleUrls: ['./ticket-animation.component.scss']
})
export class TicketAnimationComponent {
    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(private applicationFacade: ApplicationFacade) {}
}
